import { ActionReducerMap } from '@ngrx/store';
import { AddressModalInterface } from './data/actions/addresses-modal.actions';
import { NotificationStateInterface } from './data/actions/notifications.actions';
import * as groupView from './ui/shared/modules/group-view/group-view.reducer';
import * as prime from './data/reducers/prime.reducer';
import * as primeSubs from './data/reducers/prime.subscription.reducer';
import * as scheduleOrder from './data/reducers/scheduler-modal.reducer';
import * as setHeader from './data/reducers/set-header.reducer';
import * as setPillReminderConfig from './data/reducers/set-pill-reminder-config.reducer';
import * as saveSubscriptionOutOfStock from './data/reducers/subscription-out-of-stock.reducer';
import * as addressValidate from './data/reducers/address-validate.reducer'
import * as modifaceConfig from './data/reducers/modiface-config.reducer';
import * as mainBanners from './data/reducers/main-banners.reducer';
import * as addresses from './data/reducers/addresses-modal.reducer';
import * as customTag from './data/reducers/custom-tag.reducer';
import * as utils from './data/reducers/utils.reducer';
import * as notifications from './data/reducers/notifications.reducer';

export interface AppState {
  groupView: groupView.State,
  prime: prime.PrimeState,
  primeSubs: primeSubs.PrimeSubscriptionState,
  schedule: scheduleOrder.SchedulerState,
  setHeader: setHeader.StateHeader,
  setPillReminderConfig: setPillReminderConfig.StatePillReminderConfig,
  saveSubscriptionOutOfStock: saveSubscriptionOutOfStock.StateInit,
  saveAddressValidation: addressValidate.AddressValidate
  modifaceConfig: modifaceConfig.StateModifaceConfig,
  mainBanners: mainBanners.MainBannersState,
  addressModal: AddressModalInterface
  customTag : customTag.CustomTagState,
  utils : utils.iUtilsState,
  notificationState: NotificationStateInterface
}

export const appReducers: ActionReducerMap<AppState> = {
  groupView: groupView.groupViewReducer,
  prime: prime.primeReducer,
  primeSubs: primeSubs.primeSubscriotionReducer,
  schedule: scheduleOrder.schedulerReducer,
  setHeader: setHeader.setHeaderReducer,
  setPillReminderConfig: setPillReminderConfig.setPillReminderConfigReducer,
  saveSubscriptionOutOfStock: saveSubscriptionOutOfStock.subscriptionOutOfStockReducer,
  saveAddressValidation: addressValidate.addressValidate,
  modifaceConfig: modifaceConfig.modifaceConfigReducer,
  mainBanners: mainBanners.mainBannersReducer,
  addressModal: addresses.addressesModalReducer,
  customTag: customTag.customTagReducer,
  utils: utils.setUtilsReducer,
  notificationState: notifications.NotificationReducer,
}
